import { forwardRef, useMemo } from "react";
import { SelectInstance } from "react-select";
import { prettifyEnumLabel } from "../../../../core/utils/enum";
import { RefType } from "../../../../types";
import { genericMemo } from "../../../../utils";
import { SimpleSelect, SimpleSelectOptionType, SimpleSelectProps } from "../SimpleSelect";

export type EnumSelectProps<
  T extends string | number | boolean,
  IsMulti extends boolean = boolean,
  E = any
> = Omit<SimpleSelectProps<T, IsMulti>, "options"> & {
  enumType?: E,
}

const EnumSelectComponent = <
  T extends string | number | boolean,
  IsMulti extends boolean = boolean,
  E = any
>(props: EnumSelectProps<T, IsMulti, E>) => <></>;
export type EnumSelectComponentType = typeof EnumSelectComponent;

function defaultGetOptionLabel<T extends string | number | boolean>(data: T) {return prettifyEnumLabel<T>(data);}

export const EnumSelect = genericMemo(forwardRef(<T extends string | number | boolean, IsMulti extends boolean = boolean, E = any>(
  {
    enumType,
    ...props
  }: EnumSelectProps<T, IsMulti, E>,
  ref: RefType<SelectInstance<SimpleSelectOptionType<T>, IsMulti>>,
) => {
  return (
    <SimpleSelect<T, IsMulti>
      options={useMemo(() => Object.values(enumType || {}) as T[], [ enumType ])}
      getOptionLabel={defaultGetOptionLabel}
      {...props}
      ref={ref}
    />
  );
}) as EnumSelectComponentType);


